var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"notification-bar"},[_vm._m(0),_c('div',{staticClass:"notification"},[_c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"notification-item"},[_vm._v(" "+_vm._s(_vm.notifications)+" ")])])],1)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificationDesign"},[_c('div',{staticClass:"notificationRadio"})])
}]

export { render, staticRenderFns }